export const endPoints = "https://iqr.ryscocorrosion.com/iqr_system_backend/api/"; //"http://127.0.0.1:8000/api/";